import { ISelectionList, SelectionListServant } from '../../global/servants/selection_list_servant';
import { IDatasource, IDatasourceConstructor } from 'utility-ng-kernel';
import { IKeyValueHooks } from 'core-ts-types';
import { Major } from '../builders/major_builder';

interface ITransferMajorsDatasourceModel {
  majorsSelection: ISelectionList;
  hasMore: boolean;
}

export interface ITransferMajorsDatasource extends IDatasource<Major>, IKeyValueHooks<Major> {
  readonly model: ITransferMajorsDatasourceModel;
}

angular
  .module('capability-ng-transfer')
  .factory('ngTransferMajorsDatasource', function(
    ngMajorBuilder: typeof Major,
    ngSelectionListServant: SelectionListServant,
    Datasource: IDatasourceConstructor<Major>
  ): ITransferMajorsDatasource {
    return new Datasource<Major, ITransferMajorsDatasourceModel>({
      builderType: ngMajorBuilder,
      mergeStrategy: 'merge'
    }).includeModel({
      majorsSelection: ngSelectionListServant.setMaximum(ngSelectionListServant.build(), 3),
      hasMore: false
    });
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/datasources/transfer_majors_datasource.ts